<script>
  import { onMount, tick } from 'svelte';
  import Zoom from './Zoom.svelte'  
  import { getPgCount, getArticles, setArticles, setState, setUrl } from './logic'
  import { logged, page, pagenum } from './stores'
	import Paging from './Paging.svelte';
  
  // export let issueId
  export let issue
  const index = 'blocks'
  let pgCount = 2
  // let left = 1
  // export {left as pg}
  let data  
  let modified = false
  let ratified = '', excluded = ''
  let from = 1
  let to = 1
  let down = 0
  let tonode
  let error
  
  onMount(async () => {
    await get()
  })
  
  async function get() {
    ({ error, data } = await getArticles(issue.id, index))
    console.log('get', data)
    
    if (data) {
      pgCount = getPgCount(data)
      await tick()
      modified = false
    }
  }

  async function setArticle() {
    error = await setArticles(data, issue.id, index)
    console.log('res1', error)
    if (!error) { 
      modified = false
      error = await setState(issue.id, 'cleaning', $logged)
      console.log('res1b', error)
    }
  }

  async function ratify() {
    error = await setArticle()
    console.log('res2', error)
    if (!error) error = await setState(issue.id, 'cleaned', $logged)
    console.log('res2b', error)
    if (!error) {
      ratified = 'shváleno'
      setTimeout(() => {$page = 'list'}, 1000)
    }
  }

  async function exclude() {
    error = await setState(issue.id, 'exclude', $logged)
    console.log('res3', error)
    if (!error) {
      excluded = 'vyřazeno'
      setTimeout(() => {$page = 'list'}, 1000)
    }
  }
  
  const long = (par) => {
    down = par      
    setTimeout(() => {
      console.log('long', down, par)
      if (down === par) {
        from = par
        to = par
        tonode.focus()
      }
    }, 1000)
  }

  // $: if (left < 1) left = 1
  // $: if (left > pgCount) left = pgCount
  $: if (data) modified = true
  // $: if (from > to) to = from
</script>
  <!-- {JSON.stringify(data)}  -->
    <p class="mb-2">Uloženo: 
      <span class="ready" class:modified>{modified? 'ne' : 'ano'}</span>    
      <input type="button" class="btn btn-green py-0.5" value="uložit" disabled={!modified} on:click|preventDefault={setArticle} />
      {#if $pagenum === pgCount}
        <input type="button" class="btn btn-green py-0.5" value="schválit" on:click|preventDefault={ratify} />
        {#if ratified}<span class="success">{ratified}</span>{/if}
      {/if}
      {#if error}<span class="error">{error}</span>{/if}
      <!-- <input class="right" type="button" value="reset" disabled={!modified} on:click|preventDefault={get} /> -->
    </p>
    <!-- {JSON.stringify(data)} -->
    <!--{modified} {data?.length} {JSON.stringify(state)} {pgCount} -->
    
    {#if data}
      <Zoom src="/issue/{issue.id}/{$pagenum}" let:params>
        <!-- {JSON.stringify(params)} -->
        <div>
          {#if !params.moving}
            {#each data as article}
              <!-- {JSON.stringify(article)} -->
              {#each article.groups as group, order}
                {#if +group.page === $pagenum}
                  <div class="group"
                      style:background-color={group.isIgnored ? '' : 'rgba(149, 165, 166, 0.5)'}
                      style:top="{group.vpos*params.scale+params.offsety}px"
                      style:left="{group.hpos*params.scale+params.offsetx}px"
                      style:width="{group.width*params.scale}px"
                      style:height="{group.height*params.scale}px"
                  >
                    <span style:background-color={group.isIgnored ? 'grey' : 'blue'}
                      on:mousedown|stopPropagation={() => {group.isIgnored = !group.isIgnored; long(order+1)}}
                      on:mouseup={() => down = 0}
                    >
                      {order+1}
                    </span>                    
                  </div>
                {/if}
              {/each}
            {/each}
          {/if}
        </div>
      </Zoom>
      <div class="flex justify-between mt-1">
        <div class="">
          od
          <input type="number" class="input h-8" bind:value={from} min="1" max="{data[0].groups.length}"
            on:change={() => {if (from > to) to = from}}
          />
          do
          <input type="number" class="input h-8" bind:this={tonode} bind:value={to} min="1" max="{data[0].groups.length}"
            on:blur={() => {if (from > to) to = from}}
          />
          <button type="button" class="btn btn-green" on:click={() => {for (let i=from-1; i<to; i++) data[0].groups[i].isIgnored = true}}>ignorovat</button>
        </div>
        <span class="mr-[15%]">
          <Paging id={issue.id} {pgCount}/>
        </span>
        <div class="">
          {#if excluded}<span class="success">{excluded}</span>{/if}
          <button type="button" class="btn btn-green" on:click={exclude}>vyřadit</button>
        </div>
      </div>
    {/if}
  
  
<style>
  p {
    margin-top: 0px;
  }

  input[type=number] {
    width: 4.5em;
    padding: 5px;
  }
</style>